import { z } from "zod";

export const instructorSchema = z.object({
  _id: z.string(),
  name: z.string(),
  phone: z.string(),
  image: z.string().nullable(),
  title: z.string(),
  expertise: z.string(),
  introduction: z.string(),
  createdTime: z.number(),
  updatedTime: z.number(),
});

export type Instructor = z.infer<typeof instructorSchema>;